import React from 'react';
import { View } from 'react-native';
import { CARD_SIZE } from '../../config/style';

const CardSeparator = () => <View style={{ height: CARD_SIZE.marginTop }} />;

export default CardSeparator;
